import { callRPC, callRPCGetResponse, HttpMethod } from "./rpc.service";

export async function getSummaryItemFMISByMemoIds(memoIds: number[]) {
  return await callRPCGetResponse(HttpMethod.POST, "fmis/SummaryItem", {
    MemoID: memoIds,
  });
}
